export default function brand_details()
{
    return({
        //Company Information
        name: "NPI SOC",
        subtitle: "Enterprise Orchestrator",
        sub_entity_name: "Programmes",
        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-logo")
        .replace(/['"]+/g, "")
    });
}